<template>
    <div class="">          
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="gradation-title-wrapper mb-2">
                    <vs-button color="primary" type="border" radius icon-pack="feather" icon="icon-arrow-left" class="mb-2 mt-4 text-primary" @click="back"></vs-button>
                    <div class="gradation-title-wrap mt-6">
                        <h1 class="heading">Edit <span class="text-color-primary">Vacant Property</span></h1>
                    </div>
                </div>
            </div>
        </div>
        <vx-card title="" class="mt-4" no-shadow card-border>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Property Address</span>
                        </div>
                        <div class="vx-col w-full">
                            <span class="block vs-input--view" v-text="addProperty.address.address1"></span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Property Type</span>
                        </div>
                        <div class="vx-col w-full">
                            <v-select name="property type" :reduce="item => item.id" v-validate="'required'" v-model="addProperty.portion_type_id" :clearable="false" :options="portionTypes" placeholder="Select" />
                            <span class="text-danger text-sm" v-show="errors.has('property type')">{{ errors.first('property type') }}</span>
                        </div>
                    </div>
                </div>
            </div>            
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Bed Rooms</span>
                        </div>
                        <div class="vx-col w-full">
                            <v-select name="portion type" :reduce="item => item.id" v-validate="'required'" v-model="addProperty.property_type_id" :clearable="false" :options="propertyTypes" placeholder="Select" />
                            <span class="text-danger text-sm" v-show="errors.has('portion type')">{{ errors.first('portion type') }}</span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Bath Rooms</span>
                        </div>
                        <div class="vx-col w-full">
                            <vs-input class="w-full" type="number" v-validate="'required'" name="bath rooms" v-model="addProperty.bath_rooms" />
                            <span class="text-danger text-sm" v-show="errors.has('bath rooms')">{{ errors.first('bath rooms') }}</span>
                        </div>
                    </div>
                </div>   
            </div>               
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Security Deposit</span>
                        </div>
                        <div class="vx-col w-full">
                            <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                    <money class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="addProperty.security_deposit" name="security deposit" v-bind="money" v-validate="'required'"></money>
                                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                </div>
                            </div>
                            <span class="text-danger text-sm" v-show="errors.has('security deposit')">{{ errors.first('security deposit') }}</span>
                        </div>
                    </div>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Monthly Rent</span>
                        </div>
                        <div class="vx-col w-full">
                            <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                <div class="vs-con-input">
                                    <money class="vs-inputx vs-input--input normal hasIcon" :min="0" :step="0.5" v-model="addProperty.monthly_rent" name="monthly rent" v-bind="money" v-validate="'required'"></money>
                                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-dollar-sign null icon-no-border"></i>
                                </div>
                            </div>
                            <span class="text-danger text-sm" v-show="errors.has('monthly rent')">{{ errors.first('monthly rent') }}</span>
                        </div>
                    </div>
                </div>
            </div>              
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Status</span>
                        </div>
                        <div class="vx-col w-full">
                            <v-select name="status" :reduce="item => item.id" v-validate="'required'" v-model="addProperty.status_id" :clearable="false" :options="status" placeholder="Select" />
                            <span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
                        </div>
                    </div>
                </div>
            </div>    
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full" v-bind:key="index" v-for="(eligibility, index) in addProperty.eligibilities">
                    <div class="flex justify-content-between">
                        <div class="left w-full">
                            <div class="vx-row mb-4">
                                <div class="vx-col w-full">
                                    <span>Eligibility Criteria</span>
                                </div>
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" v-validate="'required'" :name="'eligibility_criteria' + index" v-model="eligibility.eligibility_criteria" />
                                    <span class="text-danger text-sm" v-show="errors.has('eligibility_criteria' + index)" v-text="errors.has('eligibility_criteria' + index) ? errors.first('eligibility_criteria' + index).replace('eligibility_criteria' + index, 'eligibility criteria') : ''"></span>
                                </div>
                            </div>
                        </div>
                        <div class="right ml-4 mt-8">
                            <vs-button radius v-show="index === 0" @click="addEligibility()" color="primary" type="filled" icon-pack="feather" icon="icon-plus"></vs-button>
                            <vs-button v-show="index !== 0" radius @click="removeEligibility(index)" color="danger" type="filled" icon-pack="feather" icon="icon-minus"></vs-button>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full" v-bind:key="index" v-for="(special, index) in addProperty.specials">
                    <div class="flex justify-content-between">
                        <div class="left w-full">
                            <div class="vx-row mb-4">
                                <div class="vx-col w-full">
                                    <span>Specials</span>
                                </div>
                                <div class="vx-col w-full">
                                    <vs-input class="w-full" :name="'special' + index" v-model="special.special" />
                                </div>
                            </div>
                        </div>
                        <div class="right ml-4 mt-8">
                            <vs-button radius v-show="index === 0" @click="addSpecial()" color="primary" type="filled" icon-pack="feather" icon="icon-plus"></vs-button>
                            <vs-button v-show="index !== 0" radius @click="removeSpecial(index)" color="danger" type="filled" icon-pack="feather" icon="icon-minus"></vs-button>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Photos</span>
                        </div>
                        <div class="vx-col w-full">
                            <div class="flex justify-content-between">
                                <div class="left w-full">
                                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                                        <div class="vs-con-input">
                                            <input type="file" ref="myFileInput" class="vs-inputx vs-input--input normal" v-on:change="attahamentFileSelected"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="right ml-4">
                                    <vs-button @click="addFile()" color="primary" type="filled">Upload</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
                <div class="vx-col sm:w-1/2 w-full">
                    <div class="demo-alignment mt-6">
                        <vs-chip transparent color="primary" class="mt-2" @click="removeFile(option, index)" v-bind:value="option.id" v-bind:key="option.id" v-for="(option, index) in addProperty.documents" closable>
                            <a :title="option.file_name" target="PmsAttachement" v-bind:href="option.document_location" type="button" >
                                {{option.file_name}}
                            </a>
                        </vs-chip>
                    </div>                    
                </div>
            </div>            
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="vx-row mb-4">
                        <div class="vx-col w-full">
                            <span>Description</span>
                        </div>
                        <div class="vx-col w-full">
                            <quill-editor name="description" v-validate="'required'" v-model="addProperty.description" :options="editorOption" class="custome-ht-150" />
                            <span class="text-danger text-sm" v-show="errors.has('description')">{{ errors.first('description') }}</span>
                        </div>
                    </div>
                </div>
            </div>    
            
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap items-center justify-end">
                        <vs-button type="filled" @click.prevent="submitForm" class="">Update Vacant Property</vs-button>
                    </div>
                </div>
            </div>   
        </vx-card>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import Datepicker from 'vuejs-datepicker'
import router from './../../../router.js'
import List from '@/js/list.js'
import VacantProperty from '@/js/vacantProperty.js'
import vSelect from 'vue-select'
import currency from 'v-currency-field'
import VueGoogleAutocomplete from 'vue-google-autocomplete'

export default {
  name: 'addProperty',
  data () {
    return {
      addProperty: {
        property_type_id: null,
        portion_type_id: null,
        address: {
          place_id: null,
          address2: ''
        },
        bed_rooms: '',
        bath_rooms: '',
        security_deposit: 0.00,
        monthly_rent: 0.00,
        eligibilities: [],
        specials: [],
        document_ids: [],
        documents: []
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'font': [] }]
          ]
        },
        placeholder: 'Message'
      },
      url: null,
      documentName: null,
      selectedFile: null,
      propertyTypes: [],
      portionTypes: [],
      status: []
    }
  },
  components: {
    Datepicker,
    'v-select': vSelect,
    quillEditor,
    currency,
    VueGoogleAutocomplete
  },
  created () {
    List.getPropertyTypes(this)
    List.getPortionTypes(this)
    List.getOccupancyStatus(this)
    VacantProperty.getVacantPropertyById(this, this.$route.params.id)
  },
  mounted () {
  },
  methods: {   
    submitForm () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.selectedFile !== null) {
            this.addProperty.documents.push({document_location: this.Url, document: this.SelectedFile, file_name: this.DocumentName, name: this.DocumentName, position: this.addProperty.documents.length})
            this.SelectedFile = null
            this.documentName = null
            this.rUrl = null
            this.$refs.myFileInput.value = ''
          }
          this.addProperty.document_ids = []
          for (let i = 0; i < this.addProperty.documents.length; i++) {
            if (this.addProperty.documents[i].id === null) {
              this.$vs.dialog({type: 'alert', color: 'danger', title: 'Upload', text: 'Please wait some files are still uploading...', accept: null})
              return
            }
            this.addProperty.document_ids.push(this.addProperty.documents[i].id)
          }

          this.$vs.loading()
          VacantProperty.updateVacantProperty(this, this.$route.params.id, this.addProperty)
        } else {
          document.getElementsByName([this.$validator.errors.items[0].field])[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
          console.log('errors', this.errors)
        }
      })
    },
    attahamentFileSelected (obj) {
      this.selectedFile = this.$refs.myFileInput.files[0]
      this.url = URL.createObjectURL(obj.target.files[0])
      this.documentName = obj.target.files[0].name
    },
    addFile () {
      if (this.selectedFile === null) {
        this.$vs.dialog({type: 'alert', color: 'danger', title: 'Upload', text: 'Please choose file', accept: null})
        return
      }
      if (this.selectedFile !== null) {
        const formData = new FormData()
        formData.append('file', this.selectedFile)
        this.addProperty.documents.push({id: null, document_location: this.url, document: this.selectedFile, file_name: this.documentName, name: this.documentName, position: this.addProperty.documents.length})
        VacantProperty.uploadFile(this, null, formData, this.addProperty.documents.length - 1)
        this.selectedFile = null
        this.documentName = null
        this.url = null
        this.$refs.myFileInput.value = ''
      }
    },
    removeFile (file, position) {
      this.addProperty.documents.splice(position, 1)
    }, 
    getAddressData (addressData, placeResultData) {
      this.addProperty.address.place_id = placeResultData.place_id
    },
    setPortionTypes (portionTypes) {
      this.portionTypes = portionTypes
    },
    setPropertyTypes (propertyTypes) {
      this.propertyTypes = propertyTypes
    },
    setOccupancyStatus (status) {
      this.status = status
    },
    addEligibility () {
      const eligibility = {
        eligibility_criteria: ''
      }
      this.addProperty.eligibilities.push(eligibility)
    },
    removeEligibility (index) {
      this.addProperty.eligibilities.splice(index, 1)
    },
    addSpecial () {
      const special = {
        special: ''
      }
      this.addProperty.specials.push(special)
    },
    removeSpecial (index) {
      console.log('index', index)
      this.addProperty.specials.splice(index, 1)
    },
    setVacantProperty (property) {
      this.addProperty = property
      if (this.addProperty.specials.length === 0) {
        this.addSpecial()
      }
      if (this.addProperty.eligibilities.length === 0) {
        this.addEligibility()
      }

    },
    fileUploaded (data, position) {
      if (this.addProperty.documents.length > position) {
        const index = this.addProperty.documents.findIndex(x => x.position === position)
        this.addProperty.documents[index].id  = data.id
        this.addProperty.documents[index].url  = data.url
      }
    },
    fileNotUploaded (message, position) {
      if (this.addProperty.documents.length > position) {
        const index = this.addProperty.documents.findIndex(x => x.position === position)
        this.addProperty.documents.splice(index, 1)
      }
      this.$vs.dialog({
        type: 'alert',
        color: 'danger',
        title: 'File',
        text: message,
        accept: null
      })
    },
    vacantPropertyUpdated (data) {
      this.$vs.loading.close()
      this.back()
      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: 'Property',
        text: data.return_message,
        accept: null
      })
    },
    vacantPropertyNotUpdated (message) {
      this.$vs.loading.close()
      this.$vs.dailog({
        type: 'alert',
        color: 'danger',
        title: 'Property',
        text: message,
        accept: null
      })
    },
    back () {
      router.go(-1)
    }
  }
}
</script>